<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-row>
                            <b-col lg="12" sm="12">
                                <b-overlay :show='loading'>
                                    <iq-card>
                                        <template slot="body">
                                            <b-row v-if="formData">
                                                <b-col>
                                                    <h4>{{$t('externalUser.faq')}}</h4>
                                                    <template>
                                                        <div class="accordion" role="tablist">
                                                            <b-card no-body class="mb-1"  v-for="(item, index) in formData" :key="index">
                                                                <b-card-header header-tag="header" class="p-1 " role="tab">
                                                                    <b-button class="text-left text-dark font-weight-bold" block v-b-toggle="'accordion-'+index"  variant="outline-info">{{$t('externalUser.q')}}{{$n(index+1)}}. {{currentLocale === 'en'? item.text_en : item.text_bn}}</b-button>
                                                                </b-card-header>
                                                                <b-collapse :id="'accordion-'+index" :visible="!index" accordion="my-accordion" role="tabpanel">
                                                                    <b-card-body>
                                                                        <b-card-text class="text-dark">{{$t('externalUser.ans')}}: {{currentLocale === 'en'? item.answer_en : item.answer_bn}}</b-card-text>
                                                                    </b-card-body>
                                                                </b-collapse>
                                                            </b-card>
                                                        </div>
                                                    </template>
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </iq-card>
                                </b-overlay>
                            </b-col>
                        </b-row>
                    </template>
                </iq-card>
            </b-col>
            <!-- <pre>{{formData}}</pre> -->
        </b-row>
    </b-container>
</template>
<script>
    import { core } from '@/config/pluginInit'
    import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
    import { TraineeProfileFaq } from '../../api/routes'
    export default {
        props: ['id'],
        components: {
        },
        created () {
            // this.checkRetailer()
            const userId = this.$store.state.Auth.authUser.id
            if (userId) {
                this.logged_user = userId
                this.getUserInfo(userId)
            }
        },
        mounted () {
            core.index()
        },
        data () {
            return {
                logged_user: null,
                saved: false,
                isApproved: false,
                trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl,
                formData: [],
                circular: []
            }
        },
        computed: {
            loading () {
                return this.$store.state.ExternalUser.static.loading
            },
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
        },
        methods: {
            async getUserInfo (id) {
                this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: true })
                const result = await RestApi.getData(trainingElearningServiceBaseUrl, TraineeProfileFaq)
                this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: false })
                if (result.success) {
                    this.formData = result.data
                } else {
                    //  this.$router.push({ name: 'external_user.stall_participant.profile_update' })
                }
            }
        }
    }
</script>
